import type { OverallStats as OverallStatsType } from '@/core/types';

export function OverallStats({ stats }: { stats: OverallStatsType }) {
  const accuracy = Math.round(stats.overall_accuracy * 100);

  return (
    <section className="border-border flex flex-col items-center gap-3 border-t py-4 text-center">
      <h3 className="text-muted-foreground text-xs font-medium tracking-wider uppercase">
        Overall
      </h3>
      <p className="text-muted-foreground flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm">
        <StatInline value={stats.memorized} label="memorized" />
        <Dot />
        <StatInline value={`${accuracy}%`} label="accuracy" />
        <Dot />
        <StatInline value={stats.total_cards} label="cards" />
        <Dot />
        <StatInline value={stats.total_sessions} label="sessions" />
      </p>
    </section>
  );
}

function StatInline({ value, label }: { value: string | number; label: string }) {
  return (
    <span>
      <span className="text-foreground font-semibold tabular-nums">{value}</span>{' '}
      <span>{label}</span>
    </span>
  );
}

function Dot() {
  return <span aria-hidden="true">·</span>;
}
